import { defineMessages } from 'react-intl';

const alreadyRegistredTranslations = defineMessages({
    ng_alreadyRegistred_title: {
        id: 'identityServer.selfRegistration.alreadyRegistred.title',
        defaultMessage: 'Already Registered',
    },
    ng_alreadyRegistred_text: {
        id: 'identityServer.selfRegistration.alreadyRegistred.text',
        defaultMessage:
            'Looks like you already got an account with us. The {deviceType} provided is already registered to an account. Please sign in, or you may recover your username and password through the sign in page. ',
    },
    ng_alreadyRegistred_close_button: {
        id: 'identityServer.selfRegistration.alreadyRegistred.button.close',
        defaultMessage: 'Close',
    },
    ng_unauthorized_title: {
        id: 'identityServer.selfRegistration.unauthorized.title',
        defaultMessage: 'Session Timeout',
    },
    ng_unAuthorized_text: {
        id: 'identityServer.selfRegistration.unauthorized.text',
        defaultMessage: 'You are being timeout because of inactivity. Please sign in again to continue',
    },
    ng_authorizationTimeout_title: {
        id: 'identityServer.selfRegistration.authorizationTimeout.title',
        defaultMessage: 'SMS Limit Reached',
    },
    ng_tooManyRequests_title: {
        id: 'identityServer.selfRegistration.tooManyRequests.title',
        defaultMessage: 'Too Many Requests',
    },
    ng_unprocessableContent_title: {
        id: 'identityServer.selfRegistration.unprocessableContent.title',
        defaultMessage: 'Unprocessable Content',
    },
    ng_authorizationTimeout_text: {
        id: 'identityServer.selfRegistration.authorizationTimeout.text',
        defaultMessage:
            'You have reached the maximum number of SMS requests for now. Please start the registration process again to continue',
    },
    ng_serviceUnavailable_title: {
        id: 'identityServer.selfRegistration.ng_serviceUnavailable_title.title',
        defaultMessage: 'SMS Service is temporary unavailable. Please try after sometime.',
    },
    ng_tooManyRequests_text: {
        id: 'identityServer.selfRegistration.tooManyRequests.text',
        defaultMessage: 'Request Failed. Please try after some time',
    },
    ng_unprocessableContent_text: {
        id: 'identityServer.selfRegistration.unprocessableContent.text',
        defaultMessage: 'Request Failed. Please try after some time',
    },
});

export default alreadyRegistredTranslations;
